export class Deferred<T = unknown> {
  promise: Promise<T>;
  // @ts-expect-error [EN-10263] - TS2564 - Property 'reject' has no initializer and is not definitely assigned in the constructor.
  reject: (arg1?: Error | null | undefined) => void;
  // @ts-expect-error [EN-10263] - TS2564 - Property 'resolve' has no initializer and is not definitely assigned in the constructor.
  resolve: (arg1: T) => void;
  fullfilled: boolean = false;

  constructor() {
    this.promise = new Promise(
      (resolve: (result: Promise<T> | T) => void, reject: (error?: any) => void) => {
        this.reject = reject;
        this.resolve = (...args) => {
          resolve(...args);
          this.fullfilled = true;
        };
      }
    );
  }
}

export default Deferred;
